import ConfusedAnimation from "../assets/confused.json";
import ClapAnimation from "../assets/clap.json";
import LikeAnimation from "../assets/like.json";
import CountDownAnimation from "../assets/countdown.json";
import { EmojiReactionType } from "./types";

export const getAnimationData = (reactionType: EmojiReactionType) => {
  switch (reactionType) {
    case "clap":
      return ClapAnimation;
    case "confused":
      return ConfusedAnimation;
    case "like":
      return LikeAnimation;
    default:
      return CountDownAnimation;
  }
};
